import { RefComponentBase, Ref, ComponentBase } from "@tblabs/truffle";


export class RadioSwitchesBuilder extends RefComponentBase<string, HTMLDivElement>
{
    protected switches = {};
    protected classWhenActive = {};

    constructor(ref: Ref<string>)
    {
        super("div", ref);
    }

    public Refresh(): void
    {
        this.switches.Keys().forEach(activator =>
        {
            const cmp = this.switches[activator];
            const classWhenActive = this.classWhenActive[activator];

            if (this.ref.value === activator)
                cmp.AddClass(classWhenActive);

            else
                cmp.RemoveClass(classWhenActive);
        });
    }

    public AddSwitch(activator: string, cmp: ComponentBase<any>, cssClassWhenActive: string)
    {
        this.switches[activator] = cmp;
        this.classWhenActive[activator] = cssClassWhenActive;
        cmp.OnClick(() => this.ref.value = activator);

        if (this.ref.value == activator)
            cmp.AddClass(cssClassWhenActive);

        if (this.ref.value == "")
            this.ref.value = activator;

        this.Append(cmp);

        return this;
    }
}
